// Public starter choice only: no account, tenant, credentials or draft data.
// Session storage survives a sign-in reload; opening the link never creates a magnet.
const KEY = 'm5m.template-entry.v1';
const TTL = 30 * 60 * 1000;
const valid = slug => typeof slug === 'string' && /^[a-z0-9_-]{1,80}$/.test(slug);
let memory = null;
export function clearTemplateEntry() {
  memory = null;
  try { sessionStorage.removeItem(KEY); } catch {}
}
export function readTemplateEntry() {
  let entry = memory;
  try { entry = JSON.parse(sessionStorage.getItem(KEY)) || entry; } catch {}
  if (!entry || !valid(entry.slug) || !Number.isFinite(entry.expires) || entry.expires <= Date.now()) {
    clearTemplateEntry(); return null;
  }
  return entry;
}
export function saveTemplateEntry(slug, resumeAfterAuth = false) {
  if (!valid(slug)) return;
  memory = {slug, resumeAfterAuth, expires: Date.now() + TTL};
  try { sessionStorage.setItem(KEY, JSON.stringify(memory)); } catch {}
}
export function captureTemplateEntry() {
  const url = new URL(window.location.href), slug = url.searchParams.get('template');
  if (slug !== null) {
    if (valid(slug)) saveTemplateEntry(slug);
    url.searchParams.delete('template');
    history.replaceState(history.state, '', url.pathname + url.search + url.hash);
  }
  return readTemplateEntry();
}
export function takeTemplateAuthReturn() {
  const entry = readTemplateEntry();
  if (!entry?.resumeAfterAuth) return null;
  saveTemplateEntry(entry.slug, false);
  return '/templates';
}
